import { z } from 'zod';

/**
 * `profile.cookieSettings` as it crosses a BFF boundary.
 *
 * **Every category is optional, and that is the contract, not a loosening.**
 * In this consent model a category the visitor was never asked about is
 * unanswered — `unset` — and unanswered is not denied. It reaches the wire as
 * an absent field, because `JSON.stringify` drops `undefined`, and it has to be
 * allowed to: a client holding a partial record (a v1 analytics-only decision,
 * say, made before the ad categories existed) has no answer to send for the
 * rest, and requiring four booleans would force it to invent denials. The
 * server side stores exactly this shape — every field on core-api's
 * `ProfileCookieSettings` is optional for the same reason.
 *
 * `consentVersion` stays required: it says which model the answers were given
 * under, and it is what drives the re-prompt. A record with answers but no
 * version cannot be told apart from a pre-category row.
 *
 * Extra keys are stripped by zod, so the object handed to core-api holds only
 * these fields.
 */
export const cookieSettingsSchema = z.object({
  performanceAnalyticsCookie: z.boolean().optional(),
  functionalCookie: z.boolean().optional(),
  adMeasurementCookie: z.boolean().optional(),
  adPersonalizationCookie: z.boolean().optional(),
  consentVersion: z.number().int(),
});
